<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Cadastrar Ferramentas em Massa
      </p>
    </div>

    <div class="col-12 q-mt-xl">
      <div
        class="row justify-between container-texto-input-search text-brand-5 text-weight-bold q-mt-lg q-mb-lg"
      >
        <span
          style="font-size: 17px"
          class="q-mb-md q-ml-md texto-titulo-tabela"
          >Lista De Produtos Criados</span
        >

        <div class="input-search-table col-md-4 col-xs-12">
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.produto"
            type="text"
            class="col-xs-12 col-sm-12"
            placeholder="Pesquisar Produto"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <div>
        <q-table
          :rows="listaProdutos"
          color="primary"
          :columns="columns"
          selection="single"
          dense
          row-key="code"
          class="my-sticky-dynamic"
          flat
          hide-pagination
          :loading="loading"
          hide-bottom
          v-model:selected="selected"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-btn
                  :text-color="props.selected ? 'black' : ''"
                  :color="props.selected ? 'accent' : 'primary'"
                  :disable="props.selected"
                  no-caps
                  dense
                  round
                  :icon="props.selected ? 'check_circle_outline' : 'add'"
                  @click="props.selected = !props.selected"
                />
              </q-td>
              <q-td>
                <div class="container-image">
                  <q-img
                    id="image-produto"
                    :src="props.row.product_images[0]?.url"
                  />
                </div>
              </q-td>
              <q-td>
                <span>{{ props.row.code }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.contract_product_description }}</span>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl borda-container" v-if="selected.length > 0">
      <div
        class="row col-12 justify-between text-brand-5 q-my-md text-weight-bold"
      >
        <span class="text-brand-5 text-weight-bold text-h6">Item 1</span>
        <div class="row items-center">
          <q-checkbox
            v-if="selected[0]?.product_images[0]?.url"
            v-model="imagemUrlItem"
            label="Enviar Imagem Item"
            :disable="selected[0]?.product_images[0]?.url == undefined"
            class="q-mt-md q-mr-md"
          />
          <UploadImageCriacaoEmMassa
            v-if="
              !imagemUrlItem || selected[0]?.product_images[0]?.url == undefined
            "
            @enviarBase64="receberBase64"
          />
        </div>
      </div>
      <div
        class="row col-9 q-col-gutter-sm mobile2 text-brand-5 text-weight-bold"
      >
        <div class="col-sm-3">
          Unidade
          <lista-unidades-select v-model="unidade"></lista-unidades-select>
        </div>
        <div class="col-sm-3">
          Código
          <q-input v-model="selected[0].code" dense outlined> </q-input>
        </div>
        <div class="col-sm-5">
          Descrição
          <q-input v-model="selected[0].contract_product_description" dense outlined> </q-input>
        </div>
        <SelectComponentGrupos
          @emitirGrupo="receberDadosGrupo"
          :subGrupoCategoriaUuid="item.subGrupoCategoriaUuid"
          :resetar="resetar"
        />
        <SelectComponentSubGrupos
          @emitirSubGrupo="receberDadosSubGrupo"
          :categoriaUuid="item.categoriaUuid"
          :resetar="resetar"
        />
        <div class="col-md-2 col-sm-6 col-xs-6">
          Série
          <q-input v-model="item.serie" dense outlined> </q-input>
        </div>

        <div
          v-if="selected[0].contracts[0]?.pivot?.price != undefined"
          class="col-md-2 col-sm-6 col-xs-6"
        >
          Valor Equipamento
          <q-input
            v-model="selected[0].contracts[0].pivot.price"
            dense
            outlined
          >
          </q-input>
        </div>
        <div v-else class="col-md-2 col-sm-6 col-xs-6">
          Valor Equipamento
          <q-input
            mask="#,##"
            reverse-fill-mask
            v-model="valorEquipamento"
            dense
            outlined
          >
          </q-input>
        </div>

        <div class="col-md-3 col-sm-12 col-xs-12">
          N. Patrimônio
          <q-input v-model="item.patrimonio" dense outlined type="text">
          </q-input>
        </div>
        <div class="col-md-3">
          <SelectComponentFornecedores
            @emitirFornecedor="receberDadosFornecedor"
            :reset="resetar"
          />
        </div>
        <div class="col-sm-2">
          Tempo de Permanência
          <q-input v-model="item.permanencia" dense outlined type="number">
          </q-input>
        </div>
        <div class="col-sm-2">
          Valor Locação
          <q-input v-model="item.valor_locacao" dense outlined> </q-input>
        </div>
        <div class="col-md-2">
          <SelectComponentTipoDocumento
            @enviarTipoDocumento="receberDadosDocumento"
            :resetar="resetar"
          />
        </div>
        <div class="col-md-2 col-sm-2">
          N. Documento
          <q-input v-model="item.documento" dense outlined> </q-input>
        </div>
        <div class="col-md-2">
          Selecione o Responsável
          <SelectComponentResponsaveis
            @emitirFuncionario="receberDadosFuncionario"
            :resetar="resetar"
          />
        </div>

        <div class="col-4">
          <div>Origem</div>
          <div class="row q-gutter-xs">
            <q-radio
              v-model="item.origem"
              val="propria"
              label="Própria"
            ></q-radio>
            <q-radio
              v-model="item.origem"
              val="locada"
              label="Locada"
            ></q-radio>
            <q-radio
              v-model="item.origem"
              val="consumo"
              label="Consumo"
            ></q-radio>
          </div>
        </div>
        <div class="col-md-2 col-sm-3">
          Multiplicador
          <q-input :disable="editar" v-model="multiplicador" dense outlined>
          </q-input>
        </div>
        <div class="col-md col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            class="q-mt-sm full-width"
            :color="editar ? 'negative' : 'primary'"
            :label="editar ? 'Cancelar' : 'Editar'"
            type="submit"
            :disable="multiplicador <= 1 || multiplicador >= 51"
            icon="add_circle_outline"
            dense
            @click="
              (editar = !editar),
                editar ? multiplicarCampos() : (listaItensMultiplicados = [])
            "
          />
        </div>
        <div v-if="!editar" class="col-md-3 col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            class="q-mt-sm full-width"
            color="positive"
            label="Criar"
            type="submit"
            icon="add_circle_outline"
            dense
            :disable="multiplicador <= 0 || multiplicador > 50"
            @click="criarFerramentas()"
          />
        </div>
      </div>
    </div>
    <div v-if="editar" class="q-mt-lg">
      <div
        v-for="(i, index) in listaItensMultiplicados"
        :key="index"
        class="q-mt-sm borda-container"
      >
        <div
          class="row col-12 justify-between text-brand-5 q-my-md text-weight-bold"
        >
          <span class="text-brand-5 text-weight-bold text-h6"
            >Item {{ index + 2 }}</span
          >
        </div>
        <div
          class="row col-9 q-col-gutter-sm mobile2 text-brand-5 text-weight-bold"
        >
          <div class="col-sm-3">
            Código
            <q-input v-model="i.nome" dense outlined> </q-input>
          </div>
          <div class="col-sm-5">
            Descrição
            <q-input v-model="i.descricao" dense outlined> </q-input>
          </div>
          <SelectComponentGrupos
            @emitirGrupo="receberGrupoMultiplicador"
            :subGrupoCategoriaUuid="i.grupoCategoria"
            @click="receberIndexGrupo(index)"
            :resetar="resetar"
            :model="i.categoriaObject"
          />

          <SelectComponentSubGrupos
            @emitirSubGrupo="receberSubGrupoMultiplicador"
            @click="receberIndexSubGrupo(index)"
            :categoriaUuid="i.categoriaUuid"
            :resetar="resetar"
            :model="i.grupoNome"
          />
          <div class="col-md-2 col-sm-6 col-xs-6">
            Série
            <q-input v-model="i.serie" dense outlined> </q-input>
          </div>

          <div class="col-md-2 col-sm-6 col-xs-6">
            Valor
            <q-input
              mask="#,##"
              reverse-fill-mask
              v-model="i.preco"
              dense
              outlined
            >
            </q-input>
          </div>

          <div class="col-md-3 col-sm-12 col-xs-12">
            N. Patrimônio
            <q-input v-model="i.patrimonio" dense outlined type="text">
            </q-input>
          </div>
          <div class="col-md-4">
            <SelectComponentFornecedores
              @emitirFornecedor="receberDadosFornecedorMultiplicador"
              :reset="resetar"
              :titulo="'Fornecedor'"
              :model="i.fornecedor"
              @click="receberIndexGrupo(index)"
            />
          </div>
          <div class="col-sm-3">
            Tempo de Permanência
            <q-input v-model="i.permanencia" dense outlined type="number">
            </q-input>
          </div>
          <div class="col-sm-2">
            Valor Locação
            <q-input
              mask="#,##"
              reverse-fill-mask
              v-model="i.valor_locacao"
              dense
              outlined
            >
            </q-input>
          </div>
          <div class="col-md-3">
            <SelectComponentTipoDocumento
              @enviarTipoDocumento="receberDadosDocumentoMultiplicador"
              :resetar="resetar"
              :value="i.tipo_documento"
              @click="receberIndexGrupo(index)"
            />
          </div>
          <div class="col-md-3 col-sm-3">
            N. Documento
            <q-input v-model="i.documento" dense outlined> </q-input>
          </div>
          <div class="col-md-4">
            Selecione o Responsável
            <SelectComponentResponsaveis
              @emitirFuncionario="receberDadosFuncionarioMultiplicador"
              :resetar="resetar"
              :model="i.responsavelObject"
              @click="receberIndexGrupo(index)"
            />
          </div>
          <div class="col-4">
            <div>Origem</div>
            <div class="row q-gutter-xs">
              <q-radio
                v-model="i.origem"
                val="propria"
                label="Própria"
              ></q-radio>
              <q-radio v-model="i.origem" val="locada" label="Locada"></q-radio>
              <q-radio
                v-model="i.origem"
                val="consumo"
                label="Consumo"
              ></q-radio>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="editar" class="row col-12 q-mt-lg justify-end">
      <q-btn
        color="positive"
        label="Criar"
        no-caps
        class="q-mr-md"
        icon="check_circle_outline"
        @click="criarFerramentas()"
      />
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import SelectComponentGrupos from "../components/SelectComponentGrupos.vue";
import SelectComponentSubGrupos from "../components/SelectComponentSubGrupos.vue";
import SelectComponentResponsaveis from "../components/SelectComponentResponsaveis.vue";
import SelectComponentFornecedores from "../components/SelectComponentFornecedores.vue";
import SelectComponentTipoDocumento from "../components/SelectComponentTipoDocumento.vue";
import UploadImageCriacaoEmMassa from "../components/UploadImageCriacaoEmMassa.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "center",
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
];
export default {
  components: {
    SelectComponentGrupos,
    SelectComponentSubGrupos,
    SelectComponentResponsaveis,
    SelectComponentFornecedores,
    SelectComponentTipoDocumento,
    UploadImageCriacaoEmMassa,
    ListaUnidadesSelect,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    let unidade = ref("");
    const listaProdutos = ref([]);
    const selected = ref([]);
    const filtros = ref({ produto: "" });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let loading = ref(false);
    let disable = ref(false);
    const item = ref({
      uuid: "",
      nome: "",
      descricao: "",
      imagem: "",
      grupo: "",
      serie: "",
      patrimonio: "",
      fornecedorId: "",
      documento: "",
      preco: "",
      responsavelId: "",
      responsavelNome: "",
      imageObject: "",
      imagemBase64: "",
      origem: "",
      permanencia: "",
      status: "",
      tipo_documento: "",
      categoriaUuid: "",
      fornecedor: "",
      subGrupoUuid: "",
      subGrupoCategoriaUuid: "",
      responsavelObject: "",
      valor_locacao: "",
    });
    const resetar = ref(0);
    const multiplicador = ref(1);
    const listaItensMultiplicados = ref([]);
    let editar = ref(false);
    let indexGrupo = ref("");
    let indexSubGrupo = ref("");
    let file = ref(null);
    const valorEquipamento = ref("0");
    const imagemUrlItem = ref(true);

    const listarProdutosCriados = async (page = 1, rowPerPage = 6) => {
      try {
        disable.value = true;
        loading.value = true;
        const response = await store.dispatch("fer/listarProdutosCriados", {
          has_ca: "all",
          per_page: rowPerPage,
          page: page,
          search: filtros.value.produto,
        });
        listaProdutos.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const receberDadosGrupo = async (value) => {
      if (value == null) {
        return;
      }
      item.value.categoriaUuid = value.uuid;
      item.value.categoriaObject = value;
      if (value === "") {
        item.value.subGrupoCategoriaUuid = "";
        resetar.value++;
      }
    };

    const receberDadosSubGrupo = async (value) => {
      if (value === "") {
        item.value.subGrupoUuid = "";
        item.value.subGrupoCategoriaUuid = "";
        item.value.subGrupoNome = "";
        return;
      }
      item.value.subGrupoUuid = value.uuid;
      item.value.subGrupoCategoriaUuid = value.categoria_uuid;
      item.value.subGrupoNome = value.nome;
    };

    const receberDadosFornecedor = async (value) => {
      item.value.fornecedorId = value.value.id;
      item.value.fornecedor = value.value;
    };

    const receberDadosFuncionario = async (value) => {
      item.value.responsavelId = value.id;
      item.value.responsavelNome = value.nome;
      item.value.responsavelObject = value;
    };

    const receberDadosDocumento = async (value) => {
      item.value.tipo_documento = value;
    };

    const multiplicarCampos = () => {
      listaItensMultiplicados.value = [];
      for (let i = 1; i < multiplicador.value; i++) {
        listaItensMultiplicados.value.push({
          nome: selected.value[0].code,
          descricao: selected.value[0].contract_product_description,
          imagem: item.value.imagemBase64,
          categoriaUuid: item.value.categoriaUuid,
          grupo: item.value.subGrupoUuid,
          grupoNome: item.value.subGrupoNome,
          grupoCategoria: item.value.subGrupoCategoriaUuid,
          categoriaObject: item.value.categoriaObject,
          serie: item.value.serie,
          patrimonio: item.value.patrimonio,
          fornecedorId: item.value.fornecedorId,
          fornecedor: item.value.fornecedor,
          documento: item.value.documento,
          preco:
            selected.value[0]?.contracts[0]?.pivot?.price ||
            valorEquipamento.value,
          imagemBase64: item.value.imagemBase64,
          imageObject: item.value.imageObject || null,
          responsavelId: item.value.responsavelId,
          responsavelNome: item.value.responsavelNome,
          responsavelObject: item.value.responsavelObject,
          origem: item.value.origem,
          permanencia: item.value.permanencia,
          tipo_documento: item.value.tipo_documento,
          valor_locacao: item.value.valor_locacao.split(",").join("."),
        });
      }
    };

    const receberGrupoMultiplicador = (value) => {
      listaItensMultiplicados.value[indexGrupo.value].categoriaUuid =
        value.uuid;
    };

    const receberSubGrupoMultiplicador = (value) => {
      if (value === "") {
        listaItensMultiplicados.value[indexSubGrupo.value].grupo = "";
      }
      listaItensMultiplicados.value[indexSubGrupo.value].grupo = value.uuid;
      listaItensMultiplicados.value[indexSubGrupo.value].grupoCategoria =
        value.categoria_uuid;
    };

    const receberIndexGrupo = (index) => {
      indexGrupo.value = index;
    };

    const receberIndexSubGrupo = (index) => {
      indexSubGrupo.value = index;
    };

    const receberDadosDocumentoMultiplicador = (value) => {
      listaItensMultiplicados.value[indexGrupo.value].tipo_documento = value;
    };

    const receberDadosFornecedorMultiplicador = (value) => {
      listaItensMultiplicados.value[indexGrupo.value].fornecedorId =
        value.value.id;
    };

    const receberDadosFuncionarioMultiplicador = (value) => {
      listaItensMultiplicados.value[indexGrupo.value].responsavelId = value.id;
      listaItensMultiplicados.value[indexGrupo.value].responsavelNome =
        value.nome;
    };

    const criarFerramentas = async () => {
      let ferramentas = [];
      if (listaItensMultiplicados.value.length <= 0) {
        for (let i = 1; i <= multiplicador.value; i++) {
          ferramentas.push({
            grupo_ferramenta_uuid: item.value.subGrupoUuid,
            nome: selected.value[0].code,
            descricao: selected.value[0].contract_product_description,
            documento: "",
            origem: item.value.origem,
            patrimonio: item.value.patrimonio,
            preco:
              selected.value[0]?.contracts[0]?.pivot?.price
                ?.split(",")
                .join(".") || valorEquipamento.value.split(",").join("."),
            provider_id: item.value.fornecedorId,
            responsavel_id: item.value.responsavelId,
            serie: item.value.serie,
            tempo_permanencia: item.value.permanencia,
            tipo_documento: item.value.tipo_documento,
            valor_locacao: item.value.valor_locacao.split(",").join("."),
          });
        }
      } else {
        ferramentas.push({
          grupo_ferramenta_uuid: item.value.subGrupoUuid,
          nome: selected.value[0].code,
          descricao: selected.value[0].contract_product_description,
          documento: "",
          origem: item.value.origem,
          patrimonio: item.value.patrimonio,
          preco:
            selected.value[0]?.contracts[0]?.pivot?.price
              ?.split(",")
              .join(".") || valorEquipamento.value.split(",").join("."),
          provider_id: item.value.fornecedorId,
          responsavel_id: item.value.responsavelId,
          serie: item.value.serie,
          tempo_permanencia: item.value.permanencia,
          tipo_documento: item.value.tipo_documento,
          valor_locacao: item.value.valor_locacao.split(",").join("."),
        });
        for (let i = 0; i < multiplicador.value - 1; i++) {
          ferramentas.push({
            grupo_ferramenta_uuid: listaItensMultiplicados.value[i].grupo,
            nome: listaItensMultiplicados.value[i].nome,
            descricao: listaItensMultiplicados.value[i].descricao,
            documento: "",
            origem: listaItensMultiplicados.value[i].origem,
            patrimonio: listaItensMultiplicados.value[i].patrimonio,
            preco: listaItensMultiplicados.value[i]?.preco
              ?.split(",")
              .join("."),
            provider_id: listaItensMultiplicados.value[i].fornecedorId,
            responsavel_id: listaItensMultiplicados.value[i].responsavelId,
            serie: listaItensMultiplicados.value[i].serie,
            tempo_permanencia: listaItensMultiplicados.value[i].permanencia,
            tipo_documento: listaItensMultiplicados.value[i].tipo_documento,
            valor_locacao: listaItensMultiplicados.value[i].valor_locacao
              .split(",")
              .join("."),
          });
        }
      }
      try {
        await store.dispatch("fer/enviarFerramentasEmMassa", {
          vendor_id: store.state.org.unidadeData.id,
          ferramentas: ferramentas,
          imagem: imagemUrlItem.value ? null : item.value.imagemBase64,
          url_imagem: imagemUrlItem.value
            ? selected.value[0]?.product_images[0]?.url
            : null,
        });
        quasar.notify({
          message:
            "Criação está sendo feita em segundo plano, aguarde a confirmação por email ou consulte a listagem.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        selected.value = [];
        listaItensMultiplicados.value = [];
        editar.value = false;
        multiplicador.value = 1;
        item.value = {
          uuid: "",
          nome: "",
          descricao: "",
          imagem: "",
          grupo: "",
          serie: "",
          patrimonio: "",
          fornecedorId: "",
          documento: "",
          preco: "",
          responsavelId: "",
          responsavelNome: "",
          imageObject: "",
          imagemBase64: "",
          origem: "",
          permanencia: "",
          status: "",
          tipo_documento: "",
          categoriaUuid: "",
          fornecedor: "",
          subGrupoUuid: "",
          subGrupoCategoriaUuid: "",
          responsavelObject: "",
          valor_locacao: "",
        };
      } catch (error) {
        quasar.notify({
          message: error.response.data.message,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberBase64 = (value, object) => {
      item.value.imagemBase64 = value;
      item.value.imageObject = object;
    };

    const receberBase64Multiplicador = (value, object) => {
      if (indexGrupo.value == "") {
        return;
      }
      listaItensMultiplicados.value[indexGrupo.value].imagemBase64 = value;
      listaItensMultiplicados.value[indexGrupo.value].imageObject = object;
    };

    watch(
      () => filtros.value.produto,
      () => {
        listarProdutosCriados();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarProdutosCriados(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => selected.value,
      () => {
        item.value.imagemBase64 = "";
        item.value.imageObject = "";
        imagemUrlItem.value = false;
        if (selected.value[0]?.product_images[0]?.url) {
          imagemUrlItem.value = true;
        }
        if (editar.value) {
          editar.value = false;
          listaItensMultiplicados.value = [];
        }
      }
    );

    const getUnidadee = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    onMounted(() => {
      listarProdutosCriados();
      getUnidadee();
    });

    return {
      columns,
      listarProdutosCriados,
      listaProdutos,
      selected,
      filtros,
      loading,
      disable,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      item,
      receberDadosSubGrupo,
      receberDadosGrupo,
      resetar,
      receberDadosFornecedor,
      receberDadosFuncionario,
      receberDadosDocumento,
      multiplicador,
      multiplicarCampos,
      listaItensMultiplicados,
      editar,
      unidade,
      receberGrupoMultiplicador,
      receberSubGrupoMultiplicador,
      receberIndexGrupo,
      receberIndexSubGrupo,
      indexGrupo,
      indexSubGrupo,
      receberDadosDocumentoMultiplicador,
      receberDadosFornecedorMultiplicador,
      receberDadosFuncionarioMultiplicador,
      criarFerramentas,
      file,
      receberBase64,
      receberBase64Multiplicador,
      valorEquipamento,
      imagemUrlItem,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 430px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.borda-container {
  border: 1px solid #707070;
  padding: 10px 20px;
  border-radius: 4px;
}
#image-produto {
  width: 100%;
  height: 100%;
}
.container-image {
  border: 1px solid #707070;
  border-radius: 4px;
  width: 60px;
  height: 60px;
  padding: 1px;
}
</style>
